import { render } from "./WelcomeSimple.vue?vue&type=template&id=433ff462"
import script from "./WelcomeSimple.vue?vue&type=script&lang=js"
export * from "./WelcomeSimple.vue?vue&type=script&lang=js"

import "./WelcomeSimple.vue?vue&type=style&index=0&id=433ff462&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__